<div class="row mb-4" *ngIf="!searchType">
  <div class="col-md-12" style="align-items: flex-start; flex-direction: column;">
    <span style="font-size: 0.857rem;color: #0F0F1F;font-weight: 500;" class="mb-1">Search for an address: </span>
    <p-autoComplete [suggestions]="suggestions" (completeMethod)="searchAddress($event.query)" (onSelect)="setAddress($event.id)" field="name" class="autocomplete input-address" placeholder="Enter Your Postcode"></p-autoComplete>
  </div>
</div>

<div class="row mb-4" *ngIf="searchType">
  <div class="col-md-12" style="align-items: flex-start; flex-direction: column;">
    <span style="font-size: 1rem; color: #848790;" class="mb-1">Address: </span>
    <input type="text" class="p-2 input-address" placeholder="Address" style="width: 100%; height: 43px;" [(ngModel)]="address">
  </div>
</div>

<div class="row mb-4" *ngIf="searchType">
  <div class="col-md-6" style="align-items: flex-start; flex-direction: column;">
    <span style="font-size: 1rem; color: #848790;" class="mb-1">Town / City: </span>
    <input type="text" class="p-2 input-address" placeholder="Town / City" style="width: 100%; height: 43px;" [(ngModel)]="city">
  </div>
  <div class="col-md-6" style="align-items: flex-start; flex-direction: column;">
    <span style="font-size: 1rem; color: #848790;" class="mb-1">Postcode: </span>
    <input type="text" class="p-2 input-address" placeholder="Postcode" style="width: 100%; height: 43px;" [(ngModel)]="zip">
  </div>
</div>
